/**
 * GENERICS
 */

export interface CreditOffer<Type, Attributes> {
  type: Type;
  primary: boolean;
  attributes: Attributes;
}

/**
 * API
 */

export enum ApiCreditOfferTypes {
  BNPL = 'BNPL',
  TAKE3 = 'TAKE3',
  STC = 'STC',
  CTA = 'CTA',
}

export interface ApiCreditOffersRequest {
  data: {
    attributes: {
      catalogueId: string;
      price: number;
      site: 'Very';
    };
  };
}

export interface ApiCreditOffersResponse {
  data: {
    attributes: ApiCreditOffersAttributes;
  };
}

export interface ApiCreditOffersAttributes {
  apr: {
    value: number;
  };
  offers: ApiCreditOffers;
}

export type ApiCreditOffers = [ApiStcCreditOffer, ApiTake3CreditOffer, ApiBnplCreditOffer, ApiCtaCreditOffer];
export type ApiStcCreditOffer = CreditOffer<ApiCreditOfferTypes.STC, ApiStcAttributes>;
export type ApiTake3CreditOffer = CreditOffer<ApiCreditOfferTypes.TAKE3, ApiTake3Attributes>;
export type ApiBnplCreditOffer = CreditOffer<ApiCreditOfferTypes.BNPL, ApiBnplAttributes>;
export type ApiCtaCreditOffer = CreditOffer<ApiCreditOfferTypes.CTA, CtaAttributes>;

export interface ApiStcAttributes {
  minPay: ApiStcMinPay;
}

export interface ApiTake3Attributes {
  terms: ApiTake3Term[];
}

export interface ApiBnplAttributes {
  terms: ApiBnplTerm[];
}

export interface ApiStcMinPay {
  amount: number;
  percent: number;
}

export interface ApiBnplTerm {
  term: number;
  creditOfferCode: string;
  minimumOrderValue: number;
}

export interface ApiTake3Term {
  term: number;
  value: number;
}

/**
 * ADAPTED
 */

export enum CreditOfferTypes {
  BNPL = 'bnpl',
  TAKE3 = 'take3',
  STC = 'stc',
  CTA = 'cta',
}

export interface AdaptedCreditOffersResponse {
  apr: string;
  offers: CreditOffers;
  primary?: StcCreditOffer | Take3CreditOffer | BnplCreditOffer | CtaCreditOffer;
}

export interface CreditOffers {
  [CreditOfferTypes.STC]: StcCreditOffer;
  [CreditOfferTypes.TAKE3]: Take3CreditOffer;
  [CreditOfferTypes.BNPL]: BnplCreditOffer;
  [CreditOfferTypes.CTA]?: CtaCreditOffer;
}

export type StcCreditOffer = CreditOffer<CreditOfferTypes.STC, StcAttributes>;
export type Take3CreditOffer = CreditOffer<CreditOfferTypes.TAKE3, Take3Attributes>;
export type BnplCreditOffer = CreditOffer<CreditOfferTypes.BNPL, BnplAttributes[]>;
export type CtaCreditOffer = CreditOffer<CreditOfferTypes.CTA, CtaAttributes>;

export interface StcAttributes {
  amount: string;
  percent: string;
}

export interface Take3Attributes {
  firstPayment: string;
  secondPayment: string;
  thirdPayment: string;
}

export interface BnplAttributes {
  months: string;
  minimumOrderValue: string;
}

export interface CtaAttributes {
  voucherCode: string;
  startDate: string;
  endDate: string;
  cashbackDate: string;
  termLength: number;
  offerTitle: string;
  offerTerms1: string;
  offerTerms2?: string;
  offerTerms3?: string;
  offerTerms4?: string;
}
